import "@wirevod/ui/fonts.css";
import "@wirevod/ui/tokens.css";
import "@wirevod/ui/base.css";
import "./app/app.css";
import { applyStoredTheme, configureWebApp, refreshSession } from "@wirevod/app-core";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { watchSuspension } from "./api/suspension";
import { App } from "./app/App";

configureWebApp({ client: "dashboard" });
watchSuspension();
applyStoredTheme();

const root = createRoot(document.getElementById("root") as HTMLElement);

// Restore the session from the refresh cookie before the first route renders,
// so protected pages never flash the sign-in screen.
void refreshSession().finally(() => {
  root.render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});
